import { thunkHelperFactory, reduxMessage } from '@web-common/utils/redux_utils';
import { sliceStateCheck } from '@web-mail/utils/slice';
import { getIsSearchingMailByState } from '@web-mail/state/customize';
import { FolderThunks_cm } from '@web-mail/state/slice/customerMailReducer/thunks/folderThunks_cm';
import { MailListThunks_cm } from '@web-mail/state/slice/customerMailReducer/thunks/listThunk_cm';
import { getPrivilegeAsync, getModuleDataPrivilegeAsync } from '@web-common/state/reducer/privilegeReducer';
import { refreshContactData } from '@web-common/state/reducer/contactReducer';
const ReducerName = 'CustomerBoxReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
thunkHelper({
    name: 'refreshPage_cm',
    request: async ({ sliceId }, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        const state = thunkAPI.getState().mailReducer;
        if (!sliceStateCheck(state, sliceId, 'customer')) {
            return;
        }
        const isSearching = getIsSearchingMailByState(state, sliceId, 'customer');
        try {
            if (!isSearching) {
                await dispatch(getPrivilegeAsync());
                await dispatch(getModuleDataPrivilegeAsync('CONTACT'));
                await refreshContactData(true);
                await dispatch(FolderThunks_cm.refreshCustomerData_cm({
                    refresh: true,
                    sliceId,
                }));
                await dispatch(MailListThunks_cm.loadMailList_edm({
                    showLoading: false,
                    noCache: true,
                    refresh: true,
                    sliceId,
                    type: 'customer',
                }));
            }
            else {
                await dispatch(MailListThunks_cm.loadMailList_edm({
                    showLoading: true,
                    noCache: true,
                    refresh: true,
                    sliceId,
                    type: 'customer',
                }));
            }
        }
        catch (err) {
            return rejectWithValue(err);
        }
    },
    pending: (state, action) => {
        const { sliceId } = action.meta.arg || {};
        if (!sliceStateCheck(state, sliceId, 'customer')) {
            return;
        }
        state.customer[sliceId].refreshBtnLoading = true;
        const isSearching = getIsSearchingMailByState(state, sliceId, 'customer');
        if (!isSearching) {
            state.customer[sliceId].customerListLoading = true;
        }
        state.customer[sliceId].listLoading = true;
    },
    fulfilled: (state, action) => {
        var _a, _b, _c;
        const { sliceId } = action.meta.arg || {};
        if (!sliceStateCheck(state, sliceId, 'customer')) {
            return;
        }
        const { refreshHasNewMail } = state.customer[sliceId];
        const successCb = (_c = (_b = (_a = action) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.arg) === null || _c === void 0 ? void 0 : _c.successCb;
        if (successCb) {
            successCb(refreshHasNewMail);
        }
        state.customer[sliceId].refreshHasNewMail = false;
        state.customer[sliceId].customerListLoading = false;
        state.customer[sliceId].refreshBtnLoading = false;
    },
    rejected: (state, action) => {
        var _a;
        const { showMessage = true, sliceId } = action.meta.arg || {};
        if (!sliceStateCheck(state, sliceId, 'customer')) {
            return;
        }
        if (showMessage) {
            const errorMessage = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
            reduxMessage.success({ content: errorMessage });
        }
        state.customer[sliceId].refreshHasNewMail = false;
        state.customer[sliceId].customerListLoading = false;
        state.customer[sliceId].refreshBtnLoading = false;
    },
});
export const MailBoxThunks_cm = Thunks;
export const MailBoxExtraReducersList_cm = ReducersList;
